import "./welcome.scss";

import PropTypes from "prop-types";
import PubSub from "pubsub-js";
import React, { Fragment, PureComponent } from "react";

import PubSubTopics from "../../constants/pubSubTopics";
import { nativeCommsBroadcastMessageTypes } from "../../nativeComms";
import ListItemView from "../listView/ListItemView";
import ListView from "../listView/ListView";

const itemElement = (name, icon) => (
  <Fragment>
    <svg className={"icon"}>
      <use xlinkHref={`#${icon}`} />
    </svg>
    {name}
  </Fragment>
);

class WelcomeTipsListView extends PureComponent {
  constructor(props) {
    super(props);

    this.onTipClick = this.onTipClick.bind(this);
    this.tipRenderer = this.tipRenderer.bind(this);
  }

  onTipClick(path) {
    PubSub.publish(PubSubTopics.sendNativeMessage, {
      msg: nativeCommsBroadcastMessageTypes.OPEN_EXTERNAL_LINK,
      path
    });
  }

  tipRenderer(tip, isSelected, ref) {
    return (
      <ListItemView
        ref={ref}
        key={tip.fullPath}
        isSelected={isSelected}
        onClick={this.onTipClick}
        clickContext={tip.fullPath}
        middleElements={itemElement(tip.name, tip.icon)}
      />
    );
  }

  render() {
    const selectedIndex = -1;
    const onItemClick = newIndex =>
      this.onTipClick(this.props.tipList.find((item, index) => index === newIndex).fullPath);

    return (
      <div className="welcomeTipsListView">
        <ListView
          items={this.props.tipList}
          selectedItemIndex={selectedIndex}
          onItemSelect={onItemClick}
          itemRenderer={this.tipRenderer}
        />
      </div>
    );
  }
}

WelcomeTipsListView.propTypes = {
  tipList: PropTypes.array
};

export default WelcomeTipsListView;
